export var notification_en = {
    notifications: 'Notifications',
    collapse: 'Collapse',
    expand: 'Expand',
    markAsViewed: 'Mark as viewed',
    markAsNotViewed: 'Mark as not viewed',
    noSubject: 'No subject',
    endMessageWithNotifications: 'There are no earlier notifications',
    endMessageWithoutNotifications: 'No notifications right now',
};
